import {byId} from './util';
import {SET_SEARCH_PARAMS} from '../actions/ActionTypes';

const initialState = {
  byId: {},
  deckIndex: null,
  order: [],
  metricsByDeckId: {},
  currentDeckId: null
};

export function decks(state = initialState, action) {
  switch (action.type) {
  case 'INVITE_RECEIVE': {
    const invite = action.payload;
    return Object.assign({}, state, {currentDeckId: invite.deck_id});
  }
  case 'DECK_RECEIVE': {
    const newState = {};
    if (state.currentDeckId === null) {
      newState.currentDeckId = action.payload.id;
    }

    return byId(Object.assign({}, state, newState), action.payload);
  }
  case 'DECK_ORDER': {
    const deckIndex = state.deckIndex;
    const newState = Object.assign({}, state, {order: action.payload});

    if (action.payload[deckIndex] !== undefined) {
      newState.currentDeckId = action.payload[deckIndex];
    }

    return newState;
  }
  case 'DECK_SET_CURRENT': {
    return Object.assign({}, state, {currentDeckId: action.payload});
  }
  case 'DECK_INVITEE_COUNT': {
    const {deckId, unique_invited_users} = action.payload;

    const metrics = Object.assign({}, state.metricsByDeckId[deckId], {
      unique_invited_users
    });

    const metricsByDeckId = Object.assign({}, state.metricsByDeckId, {
      [deckId]: metrics
    });

    return Object.assign({}, state, {metricsByDeckId});
  }
  case SET_SEARCH_PARAMS: {
    const {deckIndex = state.deckIndex || 0} = action.payload;

    let currentDeckId = state.currentDeckId;

    if (state.order.length) {
      currentDeckId = state.order[deckIndex];
    }

    return Object.assign({}, state, {currentDeckId, deckIndex});
  }
  default:
    return state;
  }
}
